/** Height shared by both solid event blocks and ghost preview blocks. */
export const EVENT_BLOCK_HEIGHT = "h-12";
